import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import {swiperFactory} from './swiper.factory.js';

import PALETTE_SCHEMA from './swiper.palette-schema.yaml';

class SwiperFeature extends AbstractVisualFeature {
    get name() {
        return 'Swiper';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return swiperFactory(PALETTE);
    }
}

new SwiperFeature(allVisuals);
